import { Container } from '@mui/material'
import React from 'react'

const CommonContainer = ({ children, maxWidth = "lg", ...props }) => {
    return (
        <Container maxWidth={maxWidth} {...props}>
            {children}
        </Container>
    )
}

export default CommonContainer
